import {X} from "react-feather";
import React, {useRef} from "react";
import {deleteMAVFile, uploadMAVFile} from "../../services/api/admin";

const UploadMultipleImages = ({label, formik, name, disabled = false, onImageDelete}) => {
    const inputRef = useRef()
    const {errors, touched, values, setFieldValue} = formik;
    const [isLoading, setLoading] = React.useState(false)

    const handleFileSelect = async (e) => {
        const file = e.target.files[0];
        if (!file) return; // No file selected

        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await uploadMAVFile(formData);
            let myFiles = values[name];
            myFiles.push({...response.data, isNew: true});
            await setFieldValue(name, myFiles);
            setLoading(false);
        } catch (error) {
            console.error('Error uploading file:', error);
        }
    };

    const deleteSingleImage = async (index) => {
        try {
            const selectedFile = values[name][index];
            await deleteMAVFile(selectedFile.location);
            let myFiles = values[name];
            myFiles.splice(index, 1);
            if (!selectedFile.isNew)
                await onImageDelete("images", myFiles);
            await setFieldValue(name, myFiles);
        } catch (e) {
            console.log(e)
        }
    }


    return <div className="sl-width-100 sl-text-left sl-flex sl-flex-col">
                                <span
                                    className="sl-font sl-font-medium sl-text-sm sl-text-gray-700 "
                                    dangerouslySetInnerHTML={{__html: label}}/>
        <div
            className="sl-mt-2 sl-w-fill-available sl-flex sl-flex-row sl-relative sl-flex-wrap">
            {values[name].map((file, index) => {
                return <div className={"sl-relative"}>
                    <img key={index} className={"sl-ml-3 sl-m-15"} width={100} height={100}
                         style={{objectFit: 'contain'}}
                         src={file.preview} alt={label}/>

                    <X className={"sl-absolute sl-right-0 sl-cursor-pointer sl-top-0"}
                       onClick={() => deleteSingleImage(index)}/>
                </div>
            })}
        </div>

        <div className="sl-mt-2">
            <input
                ref={inputRef}
                accept=".png,.jpg,.jpeg"
                disabled={disabled}
                name={name}
                onChange={handleFileSelect}
                className="sl-hidden"
                type="file"/>

            <button
                disabled={isLoading}
                onClick={() => inputRef.current.click()}
                className="sl-btn sl-btn-primary sl-btn-lg  sl-rounded-lg sl-text-md sl-pl-20 sl-pr-20 sl-font ">
                {!isLoading && 'Add More'}
                {isLoading && <div className="sl-loader sl-m-auto "/>}
            </button>
        </div>

        {touched[name] &&
            <span className="sl-text-error-500 sl-mt-2 sl-font sl-text-sm sl-font">{errors[name]}</span>}
    </div>
}

export default UploadMultipleImages;